import { debounce } from './../utility/debounce'
import { timeline, positionInViewport } from './../utility/timeline'


// hide elements as they scroll out of view to save on
// rendering performance (browsers still render anything on
// previous cards as they're still within the viewport bounds)

function setupVisibility(els) {
	els.map(el => {
		const tl = timeline({
			beforeCalc: () => el.style.position = 'initial',
			afterCalc: () => el.style.position = '',
			start: () => positionInViewport(el, { elementY: 0, viewportY: 1 }).y,
			end: () => positionInViewport(el, { elementY: 1, viewportY: 0 }).y
		})
		tl.onUpdate((pos, details) => updateVisibility(el, pos, details))
		tl.update()
		window.addEventListener('resize', tl.update)
		window.addEventListener('DOMContentLoaded', tl.update)
	})
}

function updateVisibility(el, pos, details) {
	const isOutOfBounds = pos.percentRaw < 0 || pos.percentRaw > 1

	if (isOutOfBounds) {
		el.style.opacity = '0';
	} else {
		el.style.opacity = '';
	}
}


// sets the top offset based on the height of the element, so
// the cards stick at the bottom of their scroll position
// (updates calculation on resize and intersection events)

function setupStickyPositions(els) {

	const observer = new IntersectionObserver(handleIntersection, {
		rootMargin: `0px 0px`,
		threshold: [0.25, 0.5, 0.75]
	})

	function handleIntersection(entries, observer) {
		entries.forEach(entry => {
			setTop(entry.target)
			window.dispatchEvent(new Event('resize'))
		})
	}

	function update() {
		els.forEach(el => setTop(el))
	}

	const debouncedCalculate = debounce(update)

	function setupEvents() {
		els.map(el => observer.observe(el))
		window.addEventListener('DOMContentLoaded', update)
		window.addEventListener('resize', debouncedCalculate)
	}

	function removeEvents() {
		els.map(el => observer.unobserve(el))
		window.removeEventListener('DOMContentLoaded', update)
		window.removeEventListener('resize', debouncedCalculate)
	}

	setupEvents()
	update()
}

function setTop(el) {
	const height = el.clientHeight
	const offset = window.innerHeight - height
	el.style.top = (offset < 0) ? `${offset}px` : ''
}


// init

export default function init(selector = '.js-scroll-card') {
	const els = [...document.querySelectorAll(selector)]
	setupStickyPositions(els)
	setupVisibility(els)
}